import { Link } from 'react-router-dom';
import { categories } from '@/mocks/anime';

export default function CategoryNav() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            动漫分类
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            按类型浏览，快速找到你想看的动漫
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-xl bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-accent-100 flex items-center justify-center group-hover:bg-accent-200 transition-colors">
                <i className={`${cat.icon} text-xl md:text-2xl text-accent-600`}></i>
              </div>
              <span className="font-heading text-sm md:text-base text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-foreground-500 text-xs text-center leading-relaxed hidden sm:block">
                {cat.description}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}